const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');

// @actions
const BrokerFundLegalDocument = require('actions/brokerFundLegalDocument');

//@constants
const { CONTENT_TYPE_PDF } = require('constants/index');
const { MARKETING_REPORTS } = require('constants/flagBasedFeatures');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class BrokerFundLegalDocumentDisclaimer extends React.Component {
    constructor(props) {
        super(props);

        this.buildDisclaimerCheckboxLabel = this.buildDisclaimerCheckboxLabel.bind(this);
        this.handleDisclaimerClick = this.handleDisclaimerClick.bind(this);
    }

    buildDisclaimerCheckboxLabel() {
        const { enableTransactionCost, isAlternativeFund } = this.props;
        const fundNameLabel = <span>{this.props.fundName}</span>;
        const isInternalTransferFund = this.props.isInternalTransferFund;
        const fundamentalDataForInvestorLink = this.buildFundamentalDataForInvestorLink();
        const marketingReportsLink = this.buildMarketingReportsLink();
        const fundTransactionCostLink = enableTransactionCost
            ? this.buildFundTransactionCostLink()
            : null;
        const lastPublishedEconomicReportLink = this.buildLastPublishedEconomicReportLink();
        if (isAlternativeFund) {
            return (
                <FormattedTextWithComponents
                    value={"fundLegalDocumentDisclaimer-alternativeFunds"}
                />
            );
        } else if (!this.props.flagBasedFeatures.get(MARKETING_REPORTS)) {
            return (
                <FormattedTextWithComponents
                    value={
                        enableTransactionCost
                            ? "fundLegalDocumentDisclaimer-buySpanish"
                            : "fundLegalDocumentDisclaimer-buySpanishWithOutCost"
                    }
                    injectedComponents={[
                        fundamentalDataForInvestorLink,
                        lastPublishedEconomicReportLink,
                        fundTransactionCostLink,
                    ]}
                />
            );
        } else {
            if (!isInternalTransferFund){
                if (this.props.isSpanish) {
                    return (
                        <FormattedTextWithComponents
                            value={
                                enableTransactionCost
                                    ? "fundLegalDocumentDisclaimer-buySpanish"
                                    : "fundLegalDocumentDisclaimer-buySpanishWithOutCost"
                            }
                            injectedComponents={[
                                fundamentalDataForInvestorLink,
                                lastPublishedEconomicReportLink,
                                fundTransactionCostLink,
                            ]}
                        />
                    );
                } else {
                    return (
                        <FormattedTextWithComponents
                            value={
                                enableTransactionCost
                                    ? "fundLegalDocumentDisclaimer-buyNonSpanish"
                                    : "fundLegalDocumentDisclaimer-buyNonSpanishWithOutCost"
                            }
                            injectedComponents={[
                                fundamentalDataForInvestorLink,
                                lastPublishedEconomicReportLink,
                                marketingReportsLink,
                                fundTransactionCostLink,
                            ]}
                        />
                    );
                }
            }
            else {
                if (this.props.isSpanish) {
                    return (
                        <FormattedTextWithComponents
                            value={
                                enableTransactionCost
                                    ? "fundLegalDocumentDisclaimer-spanish"
                                    : "fundLegalDocumentDisclaimer-spanishWithOutCost"
                            }
                            injectedComponents={[
                                fundamentalDataForInvestorLink,
                                fundNameLabel,
                                lastPublishedEconomicReportLink,
                                fundTransactionCostLink,
                            ]}
                        />
                    );
                } else {
                    return (
                        <FormattedTextWithComponents
                            value={
                                enableTransactionCost
                                    ? "fundLegalDocumentDisclaimer-other"
                                    : "fundLegalDocumentDisclaimer-otherWIthOutCost"
                            }
                            injectedComponents={[
                                fundamentalDataForInvestorLink,
                                fundNameLabel,
                                lastPublishedEconomicReportLink,
                                marketingReportsLink,
                                fundTransactionCostLink,
                            ]}
                        />
                    );
                }
            }
        }
    }

    buildFundTransactionCostLink() {
        return <FormattedText value="fundLegalDocumentDisclaimer-transactionCost"/>;
    }

    buildFundamentalDataForInvestorLink() {
        return <FormattedText value="fundLegalDocumentDisclaimer-fundamentalDataForInvestor"/>;
    }

    buildLastPublishedEconomicReportLink() {
        return <FormattedText value="fundLegalDocumentDisclaimer-lastPublishedEconomicReport"/>
    }

    buildMarketingReportsLink() {
        return <FormattedText value="fundLegalDocumentDisclaimer-marketingReports"/>;
    }

    handleDisclaimerClick() {
        const immFundTransactionCostDocument = this.props.immBrokerFundLegalDocument.getIn(['fundTransactionCostDocument', this.props.fundIsin]);
        const dataBlock = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('base64Data') : '';
        const dataID = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('objectId'): '';
        const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
        downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
    }

    render() {
        const {
            immBrokerFundLegalDocument,
            disclaimerChecked,
            onDisclaimerCheckChange,
            disclaimerErrorState,
            disclaimerErrorMessage
        } = this.props;

        if (immBrokerFundLegalDocument.get('isFetching')) {
            return <LoadingSection/>;
        } else {
            return (
                <OKCheckbox
                    idName="fund-legal-document-disclaimer-checkbox"
                    label={this.buildDisclaimerCheckboxLabel()}
                    onChange={onDisclaimerCheckChange}
                    errorState={disclaimerErrorState}
                    errorMessage={disclaimerErrorMessage}
                    value={disclaimerChecked}
                />
            );
        }
    }
}

BrokerFundLegalDocumentDisclaimer.propTypes = {
    disclaimerErrorState: PropTypes.bool.isRequired,
    disclaimerErrorMessage: PropTypes.string.isRequired,
    disclaimerChecked: PropTypes.bool.isRequired,
    onDisclaimerCheckChange: PropTypes.func.isRequired,
    isSpanish: PropTypes.bool.isRequired,
    fundName: PropTypes.string.isRequired,
    fundIsin: PropTypes.string.isRequired,
    fundSecId: PropTypes.string.isRequired,
    isInternalTransferFund: PropTypes.bool.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    internalTransferOriginFundIsin: PropTypes.string,
    enableTransactionCost: PropTypes.bool.isRequired,
    flagBasedFeatures: PropTypes.object,
    isAlternativeFund: PropTypes.bool
};

BrokerFundLegalDocumentDisclaimer.defaultProps = {
    enableTransactionCost: true
};

module.exports.constructor = BrokerFundLegalDocumentDisclaimer;
module.exports.BrokerFundLegalDocumentDisclaimer = connect(
    (state) => ({
        immBrokerFundLegalDocument: state.brokerFundLegalDocument
    }),
    {
        fetchLegalDocuments: BrokerFundLegalDocument.fetchLegalDocuments
    }
)(withFeatureToggling(BrokerFundLegalDocumentDisclaimer));
